<template>
  <header
    class="ba-relative ba-px-4 ba-pt-4 ba-pb-2 ba-bg-white ba-select-none"
    :class="{
      'ba-cursor-pointer': !delegationPanel,
      'ba-pl-6': queueType === 'параллельное',
      'ba-mb-3': expanded
    }"
    @click="$emit('click')"
  >
    <vis-approval-queue-task-status-mark
      :queue-type="queueType"
      :status="item.status"
      :expired="item.expired"
    />
    <div class="ba-flex ba-items-center ba-justify-between">
      <vis-approval-queue-user
        v-if="!delegationPanel"
        :user="item.executor"
        class="ba-text-base"
      />
      <vis-approval-queue-task-delegation-control
        v-else
        class="ba-mr-2"
      />
      <div class="ba-flex ba-justify-end ba-items-center ba-ml-1 ba-leading-none">
        <!-- Текст сколько осталось времени -->
        <p
          class="ba-text-right ba-text-sm ba-font-bold"
          :class="progressColor"
        >
          {{ item.statusMessage }}
        </p>
        <!-- ======================== -->
        <!-- шеврон -->
        <span
          v-if="!delegationPanel"
          class="ba-ml-3 ba-text-text-dark-grey"
        >
          <i
            class="fa fa-chevron-down ba-duration-300"
            :class="{'ba-transform ba--rotate-180 ba-opacity-50': expanded}"
          />
        </span>
        <!-- ======================== -->
      </div>
    </div>
    <!-- ================================ -->
    <!-- отображается когда задача раскрыта -->
    <div
      v-show="expanded"
      class="ba-flex ba-justify-end ba-items-center ba-flex-wrap ba-font-bold"
      :class="{'ba-pt-2': item.expired}"
    >
      <!-- время истечения -->
      <p
        class="ba-whitespace-no-wrap"
        :class="progressColor"
      >
        <span class="ba-mr-1">{{ item.resolutionDate }}</span>
        <span class="ba-opacity-50">{{ item.resolutionTime }}</span>
      </p>
      <!-- сообщение о просрочке -->
      <p
        v-if="item.expired"
        class="ba-ml-2 ba-whitespace-no-wrap ba-text-error-strong"
      >
        {{ item.expiredMessage }}
      </p>
    </div>
    <!-- =============================== -->
    <vis-approval-queue-task-progressbar
      :progress="item.progress"
      :expired="item.expired"
      :color="progressColor"
      :width="progressWidth"
    />
  </header>
</template>

<script>
import visApprovalQueueUser from "./vis-approval-queue-user";
import visApprovalQueueTaskStatusMark from "./vis-approval-queue-task-status-mark";
import visApprovalQueueTaskDelegationControl from "./vis-approval-queue-task-delegation-control";
import visApprovalQueueTaskProgressbar from "./vis-approval-queue-task-progressbar";

export default {
  name: "vis-approval-queue-task-header",
  components: {
    visApprovalQueueUser,
    visApprovalQueueTaskStatusMark,
    visApprovalQueueTaskDelegationControl,
    visApprovalQueueTaskProgressbar
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    delegationPanel: {
      type: Boolean,
      default: false
    },
    queueType: {
      type: String,
      default: null
    },
    expanded: {
      type: Boolean,
      default: false
    },
    progressColor: {
      type: String,
      default: null
    },
    progressWidth: {
      type: String,
      default: null
    },
    isDelegated: {
      type: Boolean,
      default: false
    }
  }
}
</script>
